// src/components/preview/expense/ExpenseResolutionPreview.jsx
// ✅ 지출결의서(WEHAGO 양식) 미리보기 — 실제 렌더링/필드 매핑 로직은
// ResolutionPreview.jsx(지출/수입 결의 공용)로 이전됐고, 여기서는 기존 호출부
// (ExpenseResolutionNew.jsx, DraftDocumentDetail.jsx, ApprovalInbox.jsx,
// ApprovalInProgress.jsx)가 쓰던 prop 이름(expenseDate/payMethodLabel)과
// buildExpenseResolutionProps 반환 형태를 그대로 유지하는 얇은 래퍼.
import React from "react";
import ResolutionPreview, { buildResolutionProps } from "../resolution/ResolutionPreview";

export function buildExpenseResolutionProps(doc) {
  const p = buildResolutionProps(doc);
  return { ...p, expenseDate: p.transactionDate, payMethodLabel: p.methodLabel };
}

export default function ExpenseResolutionPreview({ expenseDate, payMethodLabel, ...rest }) {
  return (
    <ResolutionPreview
      {...rest}
      kind="expense"
      transactionDate={expenseDate}
      methodLabel={payMethodLabel}
    />
  );
}
